module.exports = __webpack_public_path__ + "components/app-promo/static/icon-app-icon-bd2ccd2ebca3a817be30d826dc5fe5c6.svg";